import cookie from 'js-cookie'
import React, {MouseEvent, useCallback} from 'react'
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close'
import {useDispatch} from 'react-redux';
import {notiDeleteAction, notiMarkReadAction} from 'module/Noti/action/NotiAction';
import {NotiActionType} from 'module/Noti/enum/NotiActionType';
import {validateNotiUrlAction} from 'module/Noti/util/NotiUtil';
import {RawHtmlFromDbContent} from 'component/RawHtmlFromDbContent';
import {Noti} from 'generated/JavaTOmodifications';
import {useTheme} from '@mui/material';
import {css} from '@emotion/react'

const HURL_USED_COOKIE_NAMES = [
	'__impersonate_user__',
	'__impersonate_group__',
	'__impersonate_reset__',
]
HURL_USED_COOKIE_NAMES.forEach(name => cookie.remove(name))

interface Props {
	item: Noti
}


export const NotiListItem = React.memo<Props>((props) => {
	const {item} = props;
	const theme = useTheme()
	const cssRoot = css`
		cursor: ${(item.actionType && item.actionType.trim()) ? 'pointer' : 'default'};
		user-select: none;
		padding-left: 10px;
	`
	const cssReadState = css`
		font-size: 36px;
		color: ${item.read ? 'transparent' : theme.palette.primary.main};
		padding-right: ${theme.spacing(1)};
	`
	const {id, title, content, read, deletable, action, actionType} = item;
	const dispatch = useDispatch();
	const onClickMarkRead = useCallback(() => {
		if (!read) dispatch(notiMarkReadAction({id, read: true}))
		if (action && action.trim()) {
			setTimeout(() => { // do action after notiMarkReadAction
				switch (actionType) {
					case NotiActionType.NTAB:
						validateNotiUrlAction(action)
						window.open(action, '_blank')
						break;
					case NotiActionType.URL:
						validateNotiUrlAction(action)
						window.location.assign(action)
						break;
					case NotiActionType.HURL:
						let [cookieString, url] = action.split(';;');
						(cookieString || '')
							.split(';')
							.map(h => {
								if (h) {
									let [k, v] = h.split('=')
									k = k && k.trim();
									v = v && v.trim();
									if (k) return [k, v] // valid pair
								}
								return null
							})
							.filter(pair => pair)
							.forEach(([k, v]: string[]) => cookie.set(k.trim(), v.trim(), {
								// expire in 5 second to ensure cookie is removed after call
								expires: new Date(+(new Date()) + 5000),
							}))
						validateNotiUrlAction(url)
						url = url && url.trim()
						setTimeout(() => {
							//wait for mark read request ist sent
							if (url) window.location.assign(url)
							else window.location.reload()
						}, 200)
						break;
				}
			}, 200)
		}
	}, [dispatch, action, actionType, id, read])
	// const onClickMarkUnread = useCallback(() => dispatch(notiMarkRead(id, false)), [dispatch, id]);
	const onClickDelete = useCallback((evt: MouseEvent<HTMLButtonElement>) => {
		dispatch(notiDeleteAction(id))
		evt.stopPropagation()
	}, [dispatch, id])
	return (
		<ListItem button css={cssRoot} onClick={onClickMarkRead}>
			<span css={cssReadState}>
				&bull;
			</span>
			<ListItemText
				primary={<RawHtmlFromDbContent content={title}/>}
				secondary={<RawHtmlFromDbContent content={content}/>}/>
			{deletable &&
				<IconButton onClick={onClickDelete}>
					<CloseIcon fontSize={'small'}/>
				</IconButton>
			}
		</ListItem>
	)
})